<ng1-profile-sso [emailAddress]="emailAddress" [hasSso]="hasSSO"></ng1-profile-sso>
